

/* BEGIN water-bottle-pouch-buyer-highlights-20260731 */
;(function () {
  var expected = ["Water-resistant 900D polyester and a durable copper-alloy buckle support reliable outdoor use.","An adjustable shoulder strap and D-ring provide flexible carrying and attachment options.","An adjustable drawcord and bottom webbing help secure different bottle sizes, while rear webbing attaches to MOLLE-compatible backpacks for expanded carry."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-unisex-tactical-durable-uv-resistant-h2o-carrier-bottle-holder-molle-compatible-water-bottle-pouch') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END water-bottle-pouch-buyer-highlights-20260731 */
